module.exports = "/fast-coin/img/coin/anim/in/coin_in_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_015.png
// module id = 2285
// module chunks = 5